import React from 'react'
import ContentLoader from 'react-content-loader'
import Paper from 'components/atoms/Paper'

const BasicItemSkeleton = props => (
  <Paper elevation={1}>
    <ContentLoader
      height={120}
      width={200}
      speed={2}
      primaryColor="#d7d6d9"
      secondaryColor="#ecebeb"
      {...props}
    >
      <circle cx="35" cy="35" r="25" />
      <rect x="75" y="20" rx="4" ry="4" width="115" height="12" />
      <rect x="75" y="40" rx="4" ry="4" width="115" height="8" />
      <rect x="10" y="70" rx="5" ry="5" width="180" height="8" />
      <rect x="10" y="85" rx="5" ry="5" width="180" height="8" />
      <rect x="10" y="100" rx="5" ry="5" width="180" height="8" />
    </ContentLoader>
  </Paper>
)

export default BasicItemSkeleton
